import { FormattedMessage } from 'react-intl'
import { Alert, AlertTitle, Button, TextField, Typography } from '@mui/material'
import { FormEvent, useState } from 'react'
import MoovyVirtualKeyboard from '../../components/moovyVirtualKeyboard'
import { useParams } from 'react-router'
import { useMutation } from '@tanstack/react-query'
import ConfigAPI from '../../apis/configuration/configAPI'
import { removePasscode, savePasscode } from '../../utils/passcodeUtils'
import axios from 'axios'
import CircularProgress from '@mui/material/CircularProgress'

function PasscodePrompt() {
  const [passcode, setPasscode] = useState('')
  const { guid } = useParams()

  // The actual method is GET, but use a mutation because of the side effect of setting the passcode in localstorage
  const mutation = useMutation({
    mutationFn: () => ConfigAPI.getConfig(guid),
    onError: () => {
      removePasscode()
    }
  })

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    tryToFetchConfiguration()
  }

  const tryToFetchConfiguration = () => {
    savePasscode(passcode)
    mutation.mutate()
  }

  const handleVirtualKeyboardInput = (key: string) => {
    if (key === 'delete') {
      setPasscode((previous) => previous.slice(0, -1))
    } else if (key === 'OK') {
      tryToFetchConfiguration()
    } else {
      setPasscode((previous) => previous + key)
    }
  }

  let errorMessageId = 'api.error.code.generic'
  if (axios.isAxiosError(mutation.error) && mutation.error.status === 401) {
    errorMessageId = 'page.passcodePrompt.configurationFetch.error.401'
  }

  return (
    <>
      <div>
        {mutation.isError && (
          <Alert severity="error">
            <AlertTitle>
              <FormattedMessage id="page.passcodePrompt.configurationFetch.error" />
            </AlertTitle>
            <FormattedMessage id={errorMessageId} />
          </Alert>
        )}
        {mutation.isPending && <CircularProgress />}
        {mutation.isSuccess && (
          <>
            <Alert severity="success">
              <FormattedMessage id="page.passcodePrompt.configurationFetch.success" />
            </Alert>
            <div style={{ marginTop: '1rem', textAlign: 'center' }}>
              <Button
                onClick={() => window.location.reload()}
                variant="contained"
              >
                <FormattedMessage id="page.passcodePrompt.configurationFetch.reload" />
              </Button>
            </div>
          </>
        )}
      </div>
      {!mutation.isSuccess && (
        <form onSubmit={handleSubmit} style={{ textAlign: 'center' }}>
          <Typography
            variant="h1"
            aria-label="Location"
            sx={{
              color: 'primary.main',
              textTransform: 'uppercase',
              marginTop: '1rem'
            }}
          >
            <FormattedMessage id="page.passcodePrompt.header" />
          </Typography>
          <div>
            <TextField
              id="passcode"
              label={<FormattedMessage id="page.passcodePrompt.label" />}
              variant="standard"
              name="passcode"
              type="password"
              value={passcode}
              autoFocus
              onChange={(e) => setPasscode(e.target.value)}
            />
          </div>
          <div>
            <Button
              variant="contained"
              disabled={!passcode}
              type="submit"
              sx={{ marginTop: 2, marginBottom: 2 }}
            >
              <FormattedMessage id="page.passcodePrompt.submit" />
            </Button>
          </div>

          <div>
            <MoovyVirtualKeyboard
              open
              handleVirtualKeyboardInput={handleVirtualKeyboardInput}
              useMoovyKeyboard
            />
          </div>
        </form>
      )}
    </>
  )
}

export default PasscodePrompt
